import { useNavigate } from "react-router-dom";
import { Users, Gauge, Fuel, Briefcase } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export const CarCard = ({ car, index = 0 }) => {
  const navigate = useNavigate();
  return (
    <div
      className="bg-white rounded-2xl border border-slate-200/80 hover:border-emerald-500/50 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group overflow-hidden cursor-pointer"
      onClick={() => navigate(`/cars/${car.id}`)}
      data-testid={`car-card-${index}`}
    >
      <div className="relative h-52 overflow-hidden bg-slate-100">
        <img
          src={car.image_url}
          alt={car.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3">
          <Badge
            className={
              car.available
                ? "bg-emerald-100 text-emerald-700 hover:bg-emerald-100 border-0"
                : "bg-amber-100 text-amber-700 hover:bg-amber-100 border-0"
            }
          >
            {car.available ? "Available" : "Rented"}
          </Badge>
        </div>
        <div className="absolute top-3 right-3">
          <Badge variant="secondary" className="bg-white/90 text-emerald-900 border-0">
            {car.category}
          </Badge>
        </div>
      </div>
      <div className="p-5">
        <h3 className="font-display font-bold text-lg text-emerald-950">{car.name}</h3>
        <div className="mt-3 grid grid-cols-4 gap-2 text-slate-500">
          <Spec icon={<Users size={15} />} label={`${car.seats}`} />
          <Spec icon={<Gauge size={15} />} label={car.zero_to_sixty} />
          <Spec icon={<Fuel size={15} />} label={car.fuel} />
          <Spec icon={<Briefcase size={15} />} label={`${car.luggage}`} />
        </div>
        <div className="mt-4 flex items-end justify-between border-t border-slate-100 pt-4">
          <div>
            <span className="font-display font-extrabold text-2xl text-emerald-900">${car.daily_rate}</span>
            <span className="text-sm text-slate-400"> / day</span>
          </div>
          <span className="text-sm font-semibold text-emerald-600 group-hover:translate-x-1 transition-transform">
            Reserve →
          </span>
        </div>
      </div>
    </div>
  );
};

const Spec = ({ icon, label }) => (
  <div className="flex flex-col items-center gap-1">
    <span className="text-emerald-600">{icon}</span>
    <span className="text-[11px] font-medium truncate max-w-full">{label}</span>
  </div>
);
